import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'mobile' })

export class MobilePipe implements PipeTransform {
    transform(input: number, args: string) {
        if (!input) {
            return '';
        }

        return `+380 (${input[0]}${input[1]}) ${input[2]}${input[3]}${input[4]} ${input[5]}${input[6]} ${input[7]}${input[8]}`;
    }
}
